import "./Distillery.module.css";
import Header from "@/reusable_sections/Header";
import Distilleryintro from "./sections/Distilleryintro";
import PremiumContentShowcase from "./sections/PremiumContentShowcase";
import Footer from "@/reusable_sections/Footer";
export default function DistilleryPage() {
  return <div>
      <Header />
      <Distilleryintro />
      <PremiumContentShowcase />
      <Footer />
    </div>;
}